/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";

interface DTOWeatherProps {
  onData(data: any): any;
}

function DTOWeather({ onData }: DTOWeatherProps) {
  const obj = useAppSelector((state) => state);

  useEffect(() => {

    const givenData = {
      profile_pic: obj.profilePicSlice.profilePic,
      emp_name:
        obj.personalInfoSlice.firstName + " " + obj.personalInfoSlice.lastName,
      emp_designation: obj.authSlice.designaion,
      awards: obj.userAwardsSlice.awards,
    };
    onData(givenData);
  }, []);

  useEffect(() => {
    const givenData = {
      emp_name:
        obj.personalInfoSlice.firstName + " " + obj.personalInfoSlice.lastName,
      profile_pic: obj.profilePicSlice.profilePic,
      emp_designation: obj.authSlice.designaion,
      awards: obj.userAwardsSlice.awards,
    };
    onData(givenData);
  }, [
    obj.personalInfoSlice,
    obj.profilePicSlice.profilePic,
    obj.authSlice.designaion,
    obj.userAwardsSlice.awards,
  ]);

  return <></>;
}
export default DTOWeather;
